import React, { useState } from 'react'
import Swal from 'sweetalert2'
import $ from 'jquery'
import Fade from 'react-reveal/Fade'
import contact1 from '../Image/contact1.webp'
import { SlUser } from "react-icons/sl";
import { HiOutlinePhone } from "react-icons/hi";
import { MdOutlineMailOutline } from "react-icons/md";
import { LuMailQuestion } from "react-icons/lu";
function Contact_Component() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNo: '',
    text: '',
  })

  const [nameError, setNameError] = useState(' ')
  const [emailError, setEmailError] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [textError, setTextError] = useState('')

  const handleInputChange = (event) => {
    const { name, value } = event.target

    if (name === 'fullName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setNameError(`Invalid name format.`)
      } else {
        setNameError('')
      }
    }

    if (name === 'email') {
      if (!value || !/\S+@\S+\.\S+/.test(value)) {
        setEmailError('Invalid email format')
      } else {
        setEmailError('')
      }
    }

    if (name === 'mobileNo') {
      if (!value || !/^\d{10}$/.test(value)) {
        setPhoneError('Length Should be 10 Digit')
      } else {
        setPhoneError('')
      }
    }
    if (name === 'text') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setTextError(`Invalid Text format.`)
      } else {
        setTextError('')
      }
    }

    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    $.ajax({
      url: 'https://forms.internselite.net/contactform',
      type: 'POST',
      data: {
        fullName: $('[name="fullName"]').val(),
        mobileNo: $('[name="mobileNo"]').val(),
        email: $('[name="email"]').val(),
        text: $('[name="text"]').val(),
      },
      success: function (response) {
        Swal.fire({
          title: 'Form Submitted!',
          text:
            "What's next? Our team will review your submission and get back to you with in 24 hours.",
          icon: 'success',
        })
        $('[name="text"]').val('')
        $('[name="fullName"]').val('')
        $('[name="mobileNo"]').val('')
        $('[name="email"]').val('')
      },
      error: function (error) {
        console.error('Error:', error)
      },
    })
  }
  return (
    <div>
      <div className="container-fluid mt-5">
        <div className="row">
          {/* ------------------------Monile view------------------------ */}
          <div className="col-md-6 d-sm-block d-md-none">
            <div className="contact-text-wrapper text-center ">
              <h4 className="fw-bold display-6">Connect Anytime, Anywhere</h4>
              <p className="py-2 mobile_contact_text_p">
                Discover the future of learning with InternsElite.
                 Contact us for inquiries, enrollment information,
                  and personalized counseling. Our expert team is here
                   to guide your education journey with advanced technology,
                    career-focused training, and dedicated support.
              </p>
            </div>
            <div>
              <img
                className="contact_img"
                src={contact1}
                alt="Contact"
                title="Contact Image"
                onContextMenu={(e) => e.preventDefault()}
              ></img>
            </div>
          </div>

          {/* ------------------------Dasktop view------------------------ */}
          <Fade big>
            <div className="col-md-6 d-none d-md-block">
              <div className="contact-text-wrapper">
                <h2 className="px-5 pt-2">Connect Anytime, Anywhere</h2>
                <p className="fs-6 px-5 pt-2">
                 Discover the future of learning with InternsElite.
                  Contact us for inquiries, enrollment information, 
                  and personalized counseling. Our expert team is here 
                  to guide your education journey with advanced technology, 
                  career-focused training, and dedicated support.
                </p>
              </div>
              <div className="text-center">
                <img
                  className="contact_img pt-5"
                  src={contact1}
                  alt="Contact"
                  title="Contact Image"
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>

            <div className="col-md-6 my-2 px-5 mt-5">
              <div className="mt-1">
                <h2 className="contact_form_main">Contact Us...</h2>
                <div className="mt-4">
                  <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6">
                          <div class="">
                            <label for="fullName" class="pb-2 px-2 contact_form">
                              <SlUser size="20px" color='#565add' />{' '}
                              Full Name
                            </label>
                            <input
                              className="py-3 form-control  shadow-sm"
                              type="text"
                              id="fullName"
                              name="fullName"
                              placeholder="Your answer"
                              value={formData.fullName}
                              onChange={handleInputChange}
                              required
                            />
                            {nameError && (
                              <div className="error text-danger">
                                {nameError}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 d-none d-md-block">
                          <div class="">
                            <label for="email" class="pb-2 px-2 contact_form">
                            <MdOutlineMailOutline size="20px" color='#565add' />{' '}
                              Email Address
                            </label>
                            <input
                              className="py-3 form-control  shadow-sm"
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Your answer"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                            />
                            {emailError && (
                              <div className="error text-danger">
                                {emailError}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 mt-4 d-sm-block d-md-none">
                          <div class="">
                            <label for="email" class="pb-2 px-2 contact_form">
                            <MdOutlineMailOutline size="20px" color='#565add' />{' '}
                              Email Address
                            </label>
                            <input
                              className="py-3 form-control shadow-sm"
                              type="email"
                              id="email"
                              name="email"
                              placeholder="Your answer"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                            />
                            {emailError && (
                              <div className="error text-danger">
                                {emailError}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                    <div class="mt-4">
                      <label for="mobileNo" class="pb-2 px-2 contact_form">
                      <HiOutlinePhone size="20px" color='#565add' />
                      {' '}Phone Number
                      </label>
                      <input
                        className="py-3 form-control shadow-sm"
                        type="tel"
                        id="mobileNo"
                        name="mobileNo"
                        placeholder="Your answer"
                        value={formData.mobileNo}
                        onChange={handleInputChange}
                        required
                      />
                      {phoneError && (
                        <div className="error text-danger">{phoneError}</div>
                      )}
                    </div>
                    <div class=" my-4">
                      <label for="text" class="pb-2 px-2 contact_form ">
                      <LuMailQuestion size="20px" color='#565add' />{' '}
                        Query
                      </label>
                      <textarea
                        rows="3"
                        className="py-3 px-3 form-control shadow-sm"
                        type="text"
                        id="text"
                        name="text"
                        placeholder="Your answer"
                        value={formData.text}
                        onChange={handleInputChange}
                        required
                      />
                      {textError && (
                        <div className="error text-danger">{textError}</div>
                      )}
                    </div>
                    <div className="row mt-2 mb-4 pt-3">
                      <div className="d-flex justify-content-center">
                        <button
                          className="shadow-sm mx-4 px-5 pt-2 pb-2 Contact_button"
                          type="submit"
                          value="Submit"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </div>
  )
}

export default Contact_Component
